/** Public resource URL path pattern (absolute pathname). */
export const PUBLIC_RESOURCE_URL_PATH_PATTERN = /^\/(api\/v2\/)?public\/resources\//;

/** Allowed public resource filenames for CSS, JS, and image assets. */
export const PUBLIC_RESOURCE_FILENAME_PATTERN = /^[\w.-]+\.(css|js|svg|png|jpg|jpeg|webp|gif|ico)$/i;

/** Allowed public resource filenames for image-only consumers (logos, backgrounds). */
export const PUBLIC_RESOURCE_IMAGE_FILENAME_PATTERN = /^[\w.-]+\.(svg|png|jpg|jpeg|webp)$/i;

/** Favicon filenames: logo image types plus ico/gif. */
export const PUBLIC_RESOURCE_FAVICON_FILENAME_PATTERN = /^[\w.-]+\.(svg|png|jpg|jpeg|webp|gif|ico)$/i;

/** Favicon data URIs: image MIME + base64 payload only (no `data:text/html` / scripts). */
export const FAVICON_DATA_URI_PATTERN =
  /^data:image\/(png|jpe?g|gif|webp|svg\+xml|x-icon|vnd\.microsoft\.icon|ico);base64,[A-Za-z0-9+/]+={0,2}$/i;

/** Cap so a settings blob cannot ship a multi-megabyte data URI as a favicon. */
export const MAX_FAVICON_DATA_URI_LENGTH = 128 * 1024;

export const PUBLIC_RESOURCES_PATH = '/public/resources/';

export const PUBLIC_RESOURCES_API_PATH = '/api/v2/public/resources/';

export const LOGIN_BACKGROUND_CSS_VAR = '--custom-login-background-image';

export const CUSTOM_STYLE_INJECTION_KEYS = {
  CUSTOM_CSS: 'custom_css',
  CUSTOM_FAVICON: 'custom_favicon',
} as const;
